module.exports = __webpack_public_path__ + "img/speaker-danmu.0d8208de.png";